import React from "react";
import Button from "../../../Button/Button";
import ProductsInfo from "../ProductsInfo/ProductsInfo";
import Style from "./OrderListOfOneRestaurant.module.scss";

const OrderListOfOneRestaurant = ({ handleOk, orderDetail }) => {
  return (
    <div className={Style.supplier}>
      <ProductsInfo data={orderDetail && orderDetail[0].products} />
      <div
        style={{ display: "flex", justifyContent: "center", padding: "1rem 0" }}
      >
        <Button
          ClassBtn={"okBtn"}
          Value={"تایید"}
          ClickHandler={handleOk}
        ></Button>
      </div>
    </div>
  );
};
export default OrderListOfOneRestaurant;
